import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useAdminAuth } from "@/components/AdminAuth";
import { navigationConfig, logoConfig } from "@/config/navigation";
import { NavigationMenu } from "@/components/navigation/NavigationMenu";
import { MobileNavigation } from "@/components/navigation/MobileNavigation";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAdminLoggedIn, logoutAdmin } = useAdminAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-border shadow-gentle">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
            <img 
              src={logoConfig.src}
              alt={logoConfig.alt}
              className="w-10 h-10 object-contain"
              width="40"
              height="40"
              loading="eager"
              decoding="async"
            />
            <div className="hidden xs:block">
              <h1 className="font-display font-bold text-lg sm:text-xl bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent leading-tight">
                {logoConfig.title}
              </h1>
              <p className="text-xs text-muted-foreground">{logoConfig.subtitle}</p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <NavigationMenu
            items={navigationConfig}
            className="hidden lg:flex items-center space-x-8"
          />

          <div className="hidden md:flex items-center space-x-4">
            {/* Bouton déconnexion admin */}
            {isAdminLoggedIn && (
              <Button 
                variant="outline" 
                onClick={logoutAdmin}
                className="text-sm"
              >
                Déconnexion Admin
              </Button>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-3 rounded-md hover:bg-accent transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
          >
            {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        <MobileNavigation
          items={navigationConfig}
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          showAdminButton={isAdminLoggedIn}
          onAdminAction={logoutAdmin}
        />
      </div>
    </header>
  );
};